export default "__VITE_ASSET__CzDeHSAB__"